import { useParams } from 'react-router-dom';
import type { Id } from 'convex/_generated/dataModel';
import { SharedGardenContainer } from '@modules/shared-garden/containers/shared_garden_container';
import { SharedGarden } from '@modules/shared-garden/views/shared_garden_view';

export function SharedGardenScreen() {
  const { gardenid } = useParams<{ gardenid: string }>();
  return <SharedGardenContainer View={SharedGarden} gardenId={gardenid as Id<'gardens'>} />;
}
